/**
 * @generated SignedSource<<0989ca75455d5152c35de98fb180c39e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useAgentSessionsData_query$data = {
  readonly agent_sessionQuery?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly agent: {
          readonly accountId: string;
          readonly name: string;
        } | null;
        readonly agentAccountId: string | null;
        readonly associatedEntities: ReadonlyArray<{
          readonly __typename: "ConfluencePage";
          readonly id: string;
          readonly links: {
            readonly base: string | null;
            readonly webUi: string | null;
          } | null;
          readonly title: string | null;
        } | {
          readonly __typename: "JiraIssue";
          readonly id: string;
          readonly key: string;
          readonly webUrl: AGG$URL | null;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null> | null;
        readonly author: {
          readonly accountId: string;
          readonly name: string;
        } | null;
        readonly conversationChannel: {
          readonly id: string | null;
          readonly isPinned: boolean | null;
          readonly isPlanning: boolean | null;
          readonly lastAgentMessageStatus: string | null;
          readonly name: string | null;
          readonly readStatus: boolean | null;
        } | null;
        readonly convoAiAgentId: string | null;
        readonly expireTime: AGG$DateTime | null;
        readonly id: string | null;
        readonly isRovo: boolean | null;
        readonly lastStateChangeAt: AGG$Long | null;
        readonly state: string | null;
        readonly stateReason: string | null;
        readonly studioAgent: {
          readonly name: string | null;
        } | null;
      } | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
  } | null;
  readonly " $fragmentType": "useAgentSessionsData_query";
};
export type useAgentSessionsData_query$key = {
  readonly " $data"?: useAgentSessionsData_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useAgentSessionsData_query">;
};

import useAgentSessionsDataPaginationQuery_graphql from './useAgentSessionsDataPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "agent_sessionQuery"
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = [
  {
    "kind": "ScalarField",
    "name": "accountId"
  },
  (v2/*: any*/)
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "aqlQuery"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "conversationWorkspaceAri"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "pageSize"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sharingContext"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shouldReadSessions"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sort"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "pageSize",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "pageSize",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": useAgentSessionsDataPaginationQuery_graphql
    }
  },
  "name": "useAgentSessionsData_query",
  "selections": [
    {
      "condition": "shouldReadSessions",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "agent_sessionQuery",
          "args": [
            {
              "kind": "Variable",
              "name": "aqlQuery",
              "variableName": "aqlQuery"
            },
            {
              "kind": "Variable",
              "name": "shardingContext",
              "variableName": "sharingContext"
            },
            {
              "kind": "Variable",
              "name": "sort",
              "variableName": "sort"
            }
          ],
          "concreteType": "AgentSessionConnection",
          "kind": "LinkedField",
          "name": "__useAgentSessionsSnapshot_agent_sessionQuery_connection",
          "plural": false,
          "selections": [
            {
              "concreteType": "AgentSessionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "AgentSession",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "state"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "stateReason"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "expireTime"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "lastStateChangeAt"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "isRovo"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "agentAccountId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "convoAiAgentId"
                    },
                    {
                      "kind": "LinkedField",
                      "name": "agent",
                      "plural": false,
                      "selections": (v3/*: any*/)
                    },
                    {
                      "kind": "LinkedField",
                      "name": "author",
                      "plural": false,
                      "selections": (v3/*: any*/)
                    },
                    {
                      "kind": "LinkedField",
                      "name": "studioAgent",
                      "plural": false,
                      "selections": [
                        (v2/*: any*/)
                      ]
                    },
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "workspaceAri",
                          "variableName": "conversationWorkspaceAri"
                        }
                      ],
                      "concreteType": "AgentConversationChannel",
                      "kind": "LinkedField",
                      "name": "conversationChannel",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v2/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "lastAgentMessageStatus"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "readStatus"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "isPlanning"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "isPinned"
                        }
                      ]
                    },
                    {
                      "kind": "LinkedField",
                      "name": "associatedEntities",
                      "plural": true,
                      "selections": [
                        (v4/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v1/*: any*/),
                            {
                              "kind": "ScalarField",
                              "name": "key"
                            },
                            {
                              "kind": "ScalarField",
                              "name": "webUrl"
                            }
                          ],
                          "type": "JiraIssue"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v1/*: any*/),
                            {
                              "kind": "ScalarField",
                              "name": "title"
                            },
                            {
                              "concreteType": "ConfluencePageLinks",
                              "kind": "LinkedField",
                              "name": "links",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "base"
                                },
                                {
                                  "kind": "ScalarField",
                                  "name": "webUi"
                                }
                              ]
                            }
                          ],
                          "type": "ConfluencePage"
                        }
                      ]
                    },
                    (v4/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "cursor"
                }
              ]
            },
            {
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "hasNextPage"
                },
                {
                  "kind": "ScalarField",
                  "name": "endCursor"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "08ae022ae062f99dbdcdd4e316a75ae8";

export default node;
